module.exports = __webpack_public_path__ + "static/media/USPMultiUse.66951113.png";